import { render } from "./assing.vue?vue&type=template&id=9467237c"
import script from "./assing.vue?vue&type=script&lang=js"
export * from "./assing.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__